'use client';

import { useCheckout } from '@/context/checkoutProvider';

const CheckoutStepper = () => {
  const { currentCheckoutStep } = useCheckout();

  return (
    <nav aria-label="Progress">
      <ol
        role="list"
        className="mt-7 flex justify-between gap-[5%] text-sm md:justify-center md:text-base lg:mt-0 lg:gap-10"
      >
        <StepItem stepNumber={1} label="Shipping" currentStep={currentCheckoutStep} />
        <StepItem stepNumber={2} label="Payment" currentStep={currentCheckoutStep} />
        <StepItem stepNumber={3} label="Review" currentStep={currentCheckoutStep} />
      </ol>
    </nav>
  );
};

// StepItem component to render each step
const StepItem = ({ stepNumber, label, currentStep }: any) => {
  const { goToCheckoutStep } = useCheckout();

  // Function to handle click on step
  const handleClick = () => {
    goToCheckoutStep(stepNumber);
  };

  return (
    <li
      role="listitem"
      onMouseOver={() => {}}
      onFocus={() => {}}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          handleClick();
        }
      }}
      onClick={handleClick}
      tabIndex={0}
      className="flex items-center gap-1 md:gap-2"
    >
      <input
        type="radio"
        id={`step${stepNumber}`}
        name="step"
        className="sr-only"
        checked={currentStep == stepNumber}
        onChange={handleClick}
      />
      <label
        htmlFor={`step${stepNumber}`}
        className={`flex h-6 w-6 cursor-pointer items-center justify-center rounded-full border-2 md:h-7 md:w-7 ${
          currentStep == stepNumber ? 'border-black' : 'border-foggyGray'
        } lg:h-10 lg:w-10`}
      >
        <h2 className="step-label">{stepNumber}</h2>
      </label>
      <h2
        className={`sm:text-xs md:text-base ${currentStep === stepNumber ? 'font-bold' : 'text-foggyGray'} lg:text-lg`}
      >
        {label}
      </h2>
    </li>
  );
};

export default CheckoutStepper;
